import { Injectable } from '@angular/core';
import { User } from './models/user.model';
@Injectable()
export class Globals {
  currentUser: User = new User();
  global_settings;
}
